const __WEBPACK_NAMESPACE_OBJECT__ = require("live/services/logger");